import { render, staticRenderFns } from "./Genes.vue?vue&type=template&id=20a3d1c9&scoped=true&"
import script from "./Genes.vue?vue&type=script&lang=js&"
export * from "./Genes.vue?vue&type=script&lang=js&"
import style0 from "./Genes.vue?vue&type=style&index=0&id=20a3d1c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3d1c9",
  null
  
)

export default component.exports